import type { SVGProps } from 'react';
const SvgGroundBlind = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
    <path
      fill="currentColor"
      d="M21.615 6.77V22H5V6.77L13.308 4zM7.077 15.077h4.846L7.077 9.538zm7.615 0h4.846V9.538zM9.154 9.538l4.154 4.154 4.154-4.154z"
    />
  </svg>
);
export default SvgGroundBlind;
